/* eslint-disable no-self-assign */
/* eslint-disable require-yield */

// import get from 'lodash/get'
import accountApi from '@/api/account'
import get from 'lodash/get'

const INITIAL_STATE = {
  token: null,
  userData: null,
  planDetails: null,
  accountList: null,
  permissions: [
    'user_create',
    'user_delete',
    'user_modify',
    'user_view',

    'userGroup_create',
    'userGroup_modify',
    'userGroup_delete',
    'userGroup_view',

    'emailCampaign_create',
    'emailCampaign_delete',
    'emailCampaign_modify',
    'emailCampaign_view',

    'smsCampaign_create',
    'smsCampaign_delete',
    'smsCampaign_modify',
    'smsCampaign_view',

    'emailTempSystem_create',
    'emailTempPerson_create',
    'emailTempSystem_modify',
    'emailTempPerson_modify',
    'emailTempSystem_delete',
    'emailTempPerson_delete',
    'emailTempSystem_view',
    'emailTempPerson_view',

    'smsTempSystem_create',
    'smsTempPerson_create',
    'smsTempSystem_modify',
    'smsTempPerson_modify',
    'smsTempSystem_delete',
    'smsTempPerson_delete',
    'smsTempSystem_view',
    'smsTempPerson_view',

    'landingpageSystem_create',
    'landingpagePerson_create',
    'landingpageSystem_modify',
    'landingpagePerson_modify',
    'landingpageSystem_delete',
    'landingpagePerson_delete',
    'landingpageSystem_view',
    'landingpagePerson_view',

    'courseTrainingEvent_create',
    'courseTrainingEvent_view',

    'courseVideo_view',
    'courseVideo_create',
    'courseVideo_modify',
    'courseVideo_delete',

    'courseVideosList_view',
    'courseVideosList_create',
    'courseVideosList_modify',
    'courseVideosList_delete',

    'phishReport_view',
    'phishReport_download',

    'courseReport_view',
    'courseReport_download',
  ],
}

export default {
  namespace: 'account',

  state: INITIAL_STATE,

  reducers: {
    init() {
      return { ...INITIAL_STATE }
    },
    setToken(state, { payload }) {
      return { ...state, token: get(payload, 'token') }
    },
    setPermissions(state, { payload }) {
      return { ...state, permissions: payload || [] }
    },
    setUserData(state, { payload = {} }) {
      return { ...state, userData: payload }
    },
    setAccountList(state, { payload }) {
      return { ...state, accountList: payload }
    },
  },

  effects: {
    *create({ payload, successCallback, errorCallback }, { call }) {
      const response = yield call(accountApi.create, payload)
      const { status } = response

      if (status === 200) {
        successCallback?.()
      } else {
        errorCallback?.()
      }
    },

    *getTestCompany({ payload, successCallback, errorCallback }, { call, select }) {
      const { account } = yield select(state => state.auth)
      const response = yield call(accountApi.getTestCompany, {
        accountId: get(account, 'accountId'),
        params: { ...payload, accountId: get(account, 'accountId') },
      })
      const { status, data: resData } = response

      let hasError = true

      if (status === 200) {
        hasError = false

        successCallback?.(resData)
      }
      if (hasError) {
        errorCallback?.()
      }
    },

    *getPermissions({ payload, successCallback, errorCallback }, { call, select, put }) {
      const { account } = yield select(state => state.auth)

      const response = yield call(accountApi.getPermissions, {
        accountId: get(account, 'accountId'),
        params: { ...payload, accountId: get(account, 'accountId') },
      })
      const { status, data: resData } = response

      let hasError = true

      if (status === 200) {
        hasError = false
        const { data } = resData
        const permissions = data
          .filter(d => d.background === true) // 僅篩選後台權限
          .map(d => d.priName)

        yield put({ type: 'account/setPermissions', payload: permissions })
        successCallback?.(permissions)
      }
      if (hasError) {
        errorCallback?.()
      }
    },

    *getSelfData({ payload, successCallback, errorCallback }, { call, select, put }) {
      const { account } = yield select(state => state.auth)
      const response = yield call(accountApi.getUserData, {
        userId: get(account, 'accountId'),
        params: {
          ...payload,
          accountId: get(account, 'accountId'),
          bo: true,
        },
      })
      const { status, data: resData } = response

      let hasError = true

      if (status === 200) {
        hasError = false

        const { data } = resData

        yield put({ type: 'account/setUserData', payload: data })

        successCallback?.(data)
      }

      if (hasError) {
        yield put({ type: 'account/setUserData' })
        errorCallback?.()
      }
    },

    *getUserData({ payload, successCallback, errorCallback }, { call, select }) {
      const { account } = yield select(state => state.auth)

      const response = yield call(accountApi.getUserData, {
        ...payload,
        params: {
          accountId: get(account, 'accountId'),
          bo: false,
        },
      })
      const { status, data: resData } = response

      let hasError = true

      if (status === 200) {
        hasError = false
        const { data } = resData

        successCallback?.(data)
      }
      if (hasError) {
        errorCallback?.()
      }
    },

    *getUserAccounts({ payload, successCallback, errorCallback }, { call, put, select }) {
      const { account } = yield select(state => state.auth)
      const response = yield call(accountApi.getUserAccounts, {
        params: { ...payload, accountId: get(account, 'accountId') },
      })
      const { status, data: resData } = response
      let hasError = true

      if (status === 200) {
        hasError = false

        yield put({ type: 'account/setAccountList', payload: resData })
        successCallback?.()
      }
      if (hasError) {
        errorCallback?.()
      }
    },

    *resetPassword({ payload, successCallback, errorCallback }, { call, put, select }) {
      const { account } = yield select(state => state.auth)
      const { userData } = yield select(state => state.account)

      const { userAccount } = userData || {}

      const response = yield call(accountApi.resetPassword, {
        data: {
          ...payload,
          username: userAccount,
        },
        params: { accountId: get(account, 'accountId'), ...payload, username: userAccount },
      })

      const { status, data: resData } = response
      let hasError = true
      if (status === 200 && resData.success === true) {
        hasError = false
        successCallback?.()
        yield put({ type: 'auth/init' })
      }
      if (hasError) {
        errorCallback?.(resData.message)
      }
    },

    *getUserRoles({ payload, successCallback, errorCallback }, { call, select }) {
      const { account } = yield select(state => state.auth)
      const response = yield call(accountApi.getUserRoles, {
        params: { ...payload, accountId: get(account, 'accountId') },
      })
      const { status, data: resData } = response
      let hasError = true

      if (status === 200) {
        hasError = false

        successCallback?.(resData)
      }
      if (hasError) {
        errorCallback?.()
      }
    },

    *getCustodians({ payload, successCallback, errorCallback }, { call, select }) {
      const { account } = yield select(state => state.auth)
      const response = yield call(accountApi.getCustodians, {
        params: { ...payload, accountId: get(account, 'accountId') },
      })
      const { status, data: resData } = response
      let hasError = true

      if (status === 200) {
        hasError = false

        successCallback?.(resData)
      }
      if (hasError) {
        errorCallback?.()
      }
    },

    *createAccount({ payload, successCallback, errorCallback }, { call, select, put }) {
      const { account } = yield select(state => state.auth)

      const response = yield call(accountApi.createAccount, {
        data: {
          ...payload,
        },
        params: { accountId: get(account, 'accountId') },
      })

      const { status, data: resData } = response
      let hasError = true

      if (status === 200) {
        const { success } = resData
        if (success) {
          hasError = false
          successCallback?.()
        }
      }

      if (hasError) {
        yield put({ type: 'app/notify', payload: { message: resData?.message, severity: 'error' } })
        errorCallback?.(resData?.message)
      }
    },

    *editAccount({ payload, successCallback, errorCallback }, { call, select, put }) {
      const { account } = yield select(state => state.auth)
      const response = yield call(accountApi.editAccount, {
        data: payload,
        params: { accountId: get(account, 'accountId') },
      })

      const { status, data: resData = {} } = response

      let error = ''

      const { success, message } = resData

      if (status === 200) {
        if (success) {
          error = undefined
          successCallback?.()
        } else {
          error = message
        }
      } else {
        error = message
      }

      if (error) {
        yield put({ type: 'app/notify', payload: { message: error, severity: 'error' } })
        errorCallback?.(error)
      }
    },

    *deleteAccount({ payload, successCallback, errorCallback }, { call, select }) {
      const { account } = yield select(state => state.auth)
      const response = yield call(accountApi.deleteAccount, {
        ...payload,
        params: { accountId: get(account, 'accountId') },
      })

      const { status, data: resData } = response

      let error = ''

      if (status === 200) {
        const { success, message } = resData
        if (success) {
          error = undefined
          successCallback?.()
        } else {
          error = message
        }
      }
      if (error) {
        errorCallback?.(error)
      }
    },

    *getCompany({ payload, successCallback, errorCallback }, { call, select }) {
      const { account } = yield select(state => state.auth)
      const response = yield call(accountApi.getCompany, {
        params: { ...payload, accountId: get(account, 'accountId') },
      })
      const { status, data: resData } = response
      let hasError = true

      if (status === 200) {
        hasError = false

        successCallback?.(resData)
      }
      if (hasError) {
        errorCallback?.()
      }
    },
  },
}
